import { shape } from 'prop-types';

import CartPropType from 'Types/cart';
import UserPropType from 'Types/user';
import CategoriesPropType from 'Types/categories';
import ProductsPropType from 'Types/products';
import ProductPropType from 'Types/product';

const InitialPagePropsType = shape({
  categories: CategoriesPropType,
  user: UserPropType,
  cart: CartPropType,
  products: ProductsPropType,
  product: ProductPropType,
});

export default InitialPagePropsType;
